import { render, staticRenderFns } from "./productSku.vue?vue&type=template&id=037f21fe&scoped=true&"
import script from "./productSku.vue?vue&type=script&lang=js&"
export * from "./productSku.vue?vue&type=script&lang=js&"
import style0 from "./productSku.vue?vue&type=style&index=0&id=037f21fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f21fe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,ALink: require('/app/components/aLink.vue').default})
